import { ITEM_KINDS, type ItemKind } from "../../../api/content/reviewDecoders";
import type { ItemAtVersion } from "../../threads/prepare";
import type { GraphNode } from "../model/workflowGraph";

/**
 * The one item a card's Edit changes (F51): the step, the sub-workflow, the artifact or the
 * item an input selects, at the exact version the Workflow pins. Edit opens the edit Thread
 * on it (F36, ADR-0031 D2), which offers the agent or the manual way. `null` when the card
 * names no stored item: the data model's terms, a selection without a named item, or a
 * step that could not be read.
 */
export function editTarget(node: GraphNode, title: string): ItemAtVersion | null {
  const item = (itemKind: ItemKind, reference: string): ItemAtVersion => ({ itemKind, name: title, reference });
  const kindOf = (kind: string) => ITEM_KINDS.find((candidate) => candidate === kind);
  switch (node.kind) {
    case "step":
      return node.step === null ? null : item("step", node.reference);
    case "sub_workflow":
      return item("workflow", node.reference);
    case "abstract_step":
      // It pins no item; a binding is changed by editing the Workflow that nests it (ADR-0043 D9).
      return null;
    case "artifact":
      return item("artifact", node.artifact.reference);
    case "selection": {
      const named = node.item;
      const kind = named === null ? undefined : kindOf(named.kind);
      return named === null || kind === undefined ? null : item(kind, named.reference);
    }
    case "terms":
      return null;
    case "item": {
      const kind = kindOf(node.item.kind);
      return kind === undefined ? null : item(kind, node.item.reference);
    }
  }
}
